/**
 * Prefer the server Cash Tracker as the cross-device source of truth.
 * Keep a local launched tracker only when the server has none yet (unsaved launch recovery).
 */
export function resolveCashTrackerFromServer(serverRaw, localRaw, hydrate) {
  const serverCash = hydrate(serverRaw);
  const localCash = hydrate(localRaw);
  if (serverCash) {
    return { cashTracker: serverCash, source: 'server', shouldUpload: false };
  }
  if (localCash) {
    return { cashTracker: localCash, source: 'local', shouldUpload: true };
  }
  return { cashTracker: null, source: 'none', shouldUpload: false };
}
